jQuery($ => {

    if ($('.a-checkbox__input')[0]) {

        var timeoutRef = false;

        $('.js-checkbox-activate-ajax').click(function () {
            var $list = $(this).parents('.js-ajax-list');

            if (timeoutRef) {
                clearTimeout(timeoutRef);
            }

            timeoutRef = setTimeout(function () {
                $list.trigger('update_checkboxes');
            }, 1000);
        });

        $('.js-ajax-list').on('update_checkboxes', function () {
            var post_id = $(this).attr('post_id'),
                unique_id = $(this).attr('unique_id'),
                items = [];

            $(this).find('.a-checkbox--checked').each(function () {
                var child = $(this).find('.a-checkbox__input'),
                    value = child.attr('value');

                items.push(value);
            });

            $.post(AJAX.url, {
                action: 'update_checkboxes',
                post_id: post_id,
                unique_id: unique_id,
                items: items
            }, function (result) {
                if (result.success) {
                    // nothing
                }
            });
        })

        $('.a-checkbox__input').change(function () {
            if ($(this).parent().hasClass('a-checkbox--checked')) {
                $(this).parent().removeClass('a-checkbox--checked');
            } else {
                $(this).parent().addClass('a-checkbox--checked');
            }
        })
    }

});